module.exports = __webpack_public_path__ + "static/media/calendarWhite.ba0f21c0.svg";